var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshCcw03 = function SvgRefreshCcw03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.833 15.627a7.8 7.8 0 0 0 .685-1.743q.232-.9.232-1.834 0-3.245-2.258-5.522T12 4.25h-.78l1.85-1.85-1.055-1.054L8.362 5l3.654 3.654L13.07 7.6l-1.85-1.85H12q2.605 0 4.428 1.834Q18.25 9.42 18.25 12.05a5.8 5.8 0 0 1-.136 1.241q-.136.62-.406 1.21zm-6.848 7.027L15.639 19l-3.654-3.654L10.93 16.4l1.85 1.85H12q-2.605 0-4.428-1.835T5.75 11.95q0-.621.136-1.241t.406-1.211L5.167 8.373a7.8 7.8 0 0 0-.685 1.743q-.232.899-.232 1.834 0 3.244 2.258 5.522T12 19.75h.78l-1.85 1.85z"
  })));
};
export default SvgRefreshCcw03;